/** An explicitly selected design keeps its valid source, regardless of later runs. */
export const chooseDesignSource = <T>(
  cached: T | null | undefined,
  draft:
    | { isStale: boolean; analysis?: T | null; updatedAt: string }
    | null
    | undefined,
  generation:
    | {
        status: string;
        result?: T | null;
        updatedAt: string;
        recoveryReason?: string | null;
      }
    | null
    | undefined,
  options: { preferSavedDesign?: boolean } = {}
): T | null | undefined => {
  const completed =
    generation?.status === 'READY' || generation?.status === 'FAILED';
  const generated =
    completed && !generation?.recoveryReason ? generation?.result : null;
  const saved = !draft?.isStale ? draft?.analysis : null;
  if (options.preferSavedDesign && saved) return saved;
  if (
    saved &&
    (!generated ||
      Date.parse(draft!.updatedAt) >= Date.parse(generation!.updatedAt))
  )
    return saved;
  // A completed run with no valid result may have changed the site pin. The
  // separate potential query can still hold the previous site's cache while
  // its invalidation refetch is pending; only the checked draft is safe here.
  return generated ?? saved ?? (completed ? null : cached);
};
